module.exports = __webpack_public_path__ + "static/media/bootstrap-stack.73844123.png";